export const FORM_FIELD_DAMAGE_DETAILS = "damage_details";
export const FORM_FIELD_ESTIMATE_AMOUNT = "estimate_amount";
export const FORM_FIELD_ESTIMATE_DETAILS = "estimate_details";
export const FORM_FIELD_JOB_SHEET_NUMBER = "job_sheet_number";

export const ONLY_ALPHA_NUMERIC_FIELDS = [];
export const ONLY_ALPHA_NUMERIC_SPACE_FIELDS = [];
export const ONLY_DIGIT_FIELDS = [FORM_FIELD_ESTIMATE_AMOUNT];

export const FIELDS_HAVING_ALPHABET_AND_SPACE_ONLY = [];
export const FIXED_LENGTH_FIELDS = [];

export const RESPONSE_FIELDS = [];
export const RESPONSE_FIELDS_DATE = [];
